import {motion} from 'framer-motion';
import {useEffect} from 'react';
import clsx from 'clsx';

import PortableText from '../portableText/PortableText.client';
import {useScrollFreeze} from '../../hooks/useScrollFreeze';
import {Image} from '@shopify/hydrogen';

export default function Popup(props: any) {
  useScrollFreeze();

  const {copy, image, title} = props.featuredItem || props;

  //listen for escape key press and props.setIsOpen(false) if pressed
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        props?.setIsOpen(false);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      className="fixed top-0 left-0 z-[9999] flex h-screen w-full items-center justify-center"
    >
      <motion.div
        onClick={() => props?.setIsOpen(false)}
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        className="fixed top-0 left-0 h-screen w-full bg-black/50"
      />
      <div className="h-min w-full max-w-[1440px] md:mx-gutter">
        <div className="relative z-10 w-full md:aspect-w-4 md:aspect-h-2">
          <div className="relative z-10 flex h-screen w-full flex-col overflow-y-scroll bg-white md:h-auto md:flex-row-reverse md:overflow-hidden md:rounded-xl">
            <div className="relative w-full md:h-full md:self-stretch">
              <div className="relative h-full w-full">
                <Image
                  width="inherit"
                  height="inherit"
                  data={image}
                  alt={title}
                  loading="lazy"
                  className="top-0 left-0 w-full md:absolute md:h-full md:object-cover"
                />
                <div className="absolute top-0 left-0 h-full w-full bg-black bg-opacity-10 object-cover" />
              </div>
              <button
                onClick={() => props?.setIsOpen(false)}
                className={clsx([
                  'absolute top-6 right-6 flex h-10 w-10 items-center justify-center rounded-full bg-opacity-30',
                  props.featuredItem ? 'bg-white' : 'bg-orange',
                ])}
              >
                <svg
                  className="rotate-45"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="transition-standard"
                    d="M13 0C12.2238 0 11.5947 0.629119 11.5947 1.40531V11.5947H1.40531C0.629119 11.5947 0 12.2238 0 13C0 13.7762 0.629119 14.4053 1.40531 14.4053H11.5947V24.5947C11.5947 25.3709 12.2238 26 13 26C13.7762 26 14.4053 25.3709 14.4053 24.5947V14.4053H24.5947C25.3709 14.4053 26 13.7762 26 13C26 12.2238 25.3709 11.5947 24.5947 11.5947H14.4053V1.40531C14.4053 0.629119 13.7762 0 13 0Z"
                    fill={props.featuredItem ? '#ffffff' : '#F27021'}
                  />
                </svg>
              </button>
            </div>
            <div className="w-full px-gutter pt-10 pb-space-l md:overflow-y-scroll md:py-16 md:px-16 lg:pb-10">
              {title && (
                <h6 className="blockH6 mb-4 font-bold text-orange">{title}</h6>
              )}
              <PortableText blocks={copy} />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
